{
  "enum": {
    "IxcTrfV1SequenceUpdateReason": {
      "BUMP": "Bump",
      "GAP_FILL": "Gap Fill",
      "MANUAL_SET": "Manual Set",
      "RESYNC": "Resync",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcTrfV1TrfReportStatus": {
      "ACKED": "Acked",
      "FAILED": "Failed",
      "PENDING": "Pending",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcTrfV1TrfSessionStatus": {
      "CONNECTING": "Connecting",
      "DISCONNECTED": "Disconnected",
      "LOGGED_ON": "Logged On",
      "STOPPED": "Stopped",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcTrfV1TrfVenue": {
      "CARTERET": "Carteret",
      "CHICAGO": "Chicago",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxcTrfV1TrfReportQueryServiceTrfReportListFilterableFields": {
      "executionId": "Execution ID",
      "hashedId": "Hashed ID",
      "status": "Status",
      "trfReportId": "TRF Report"
    },
    "IxcTrfV1TrfSessionQueryServiceTrfSessionListFilterableFields": {
      "sessionId": "Session",
      "status": "Status"
    }
  },
  "oneOf": {
    "IxcTrfV1TrfReportEventType": {
      "acked": "Acked",
      "created": "Created",
      "failed": "Failed"
    },
    "IxcTrfV1TrfSessionEventType": {
      "configUpdated": "Config Updated",
      "connected": "Connected",
      "disconnected": "Disconnected",
      "initiatorStarted": "Initiator Started",
      "initiatorStopped": "Initiator Stopped",
      "registered": "Registered",
      "resendRequested": "Resend Requested",
      "restored": "Restored",
      "sequenceNumbersReset": "Sequence Numbers Reset",
      "sequenceNumbersUpdated": "Sequence Numbers Updated"
    }
  },
  "sortEnum": {
    "IxcTrfV1TrfReportQueryServiceTrfReportListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcTrfV1TrfSessionQueryServiceTrfSessionListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}